<template>
  <div class="filter-text">
    <label :for="filter.name" class="block text-sm font-medium mb-2">
      {{ filter.displayName }}
    </label>
    <div class="relative">
      <input 
        :id="filter.name"
        type="text" 
        v-model="localValue"
        :placeholder="`Search ${filter.displayName.toLowerCase()}...`"
        class="w-full px-3 py-2 pr-8 rounded-md border border-input bg-background text-foreground"
        @input="updateValue"
      />
      <button 
        v-if="localValue"
        @click="clearValue"
        class="absolute right-2 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-foreground"
      >
        <XMarkIcon class="h-4 w-4" />
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import { XMarkIcon } from '@heroicons/vue/24/outline'

const props = defineProps({
  filter: {
    type: Object,
    required: true
  },
  activeValue: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update:value', 'clear'])

// Initialize local value
const localValue = ref('')

// Update local value when active value changes
watch(() => props.activeValue, (newValue) => {
  localValue.value = newValue || ''
}, { immediate: true })

// Debounce input updates
let debounceTimeout: NodeJS.Timeout | null = null
const updateValue = () => {
  if (debounceTimeout) {
    clearTimeout(debounceTimeout)
  }
  
  debounceTimeout = setTimeout(() => {
    if (localValue.value) {
      emit('update:value', localValue.value)
    } else {
      emit('clear')
    }
  }, 300)
}

// Clear the input
const clearValue = () => {
  localValue.value = ''
  emit('clear')
}
</script>